import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const FieldError = (props) => {
  const {children, className, style} = props;
  if (!children) {
    return null;
  }
  return (
    <strong className={classnames("help-block", className)} style={style}>
      {children.map((item, idx) => (
        <span className="erg-block" key={`err-${idx}`}>{item}</span>
      ))}
    </strong>
  );
};

FieldError.defaultProps = {
  style: {},
};
FieldError.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default FieldError;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/FieldError.js
 **/